/*
{"email":"tarjeism@gmail.com","verified":true,"auth0id":"auth0|5c90e35cf272482eb3d3f511","userid":393,"subscription":{"status":"Active","hasPending":false,"pendingSubscriptionStatus":"None","validThrough":"2019-05-31T16:16:43","lastFour":"PPAL","expiration":"NA/NA"},"settings":{"downloadLimit":10000,"maxShownRatingKey":"m"}}"
*/
export var SubscriptionStatusType;
(function (SubscriptionStatusType) {
    SubscriptionStatusType["Admin"] = "Admin";
    SubscriptionStatusType["Active"] = "Active";
})(SubscriptionStatusType || (SubscriptionStatusType = {}));
var SubscriptionInfo = /** @class */ (function () {
    function SubscriptionInfo() {
    }
    return SubscriptionInfo;
}());
var AccountSettings = /** @class */ (function () {
    function AccountSettings() {
    }
    return AccountSettings;
}());
var Purchase = /** @class */ (function () {
    function Purchase() {
    }
    return Purchase;
}());
var AccountInfo = /** @class */ (function () {
    function AccountInfo() {
        this.subscription = new SubscriptionInfo();
        this.settings = new AccountSettings();
    }
    return AccountInfo;
}());
// Signup
export var SignupResponseStatus;
(function (SignupResponseStatus) {
    SignupResponseStatus[SignupResponseStatus["UnknownError"] = 0] = "UnknownError";
    SignupResponseStatus[SignupResponseStatus["Successful"] = 200] = "Successful";
    SignupResponseStatus[SignupResponseStatus["TenantError"] = 400] = "TenantError";
    SignupResponseStatus[SignupResponseStatus["InvalidEmail"] = 406] = "InvalidEmail";
})(SignupResponseStatus || (SignupResponseStatus = {}));
export { SubscriptionInfo, AccountSettings, AccountInfo, Purchase };
